export default __webpack_public_path__ + "static/media/Dollor.2ff001e0.svg";